import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
const Dashboard = () => import("@/components/Dashboard");
const BookList = () => import("@/components/role/list");
const ChartsConfList = () => import("@/components/chart/list");
const UserList = () => import("@/components/user/list");
const UserChangePwd = () => import("@/components/user/changepwd");
const UserProfile = () => import("@/components/user/profile");
const MenuList = () => import("@/components/menu/list");
const Department = () => import("@/pages/RightsManagement/DepartmentNew");
const Custommenu = () => import("@/pages/custommenu");
const Smsmanger = () => import("@/pages/sms/list");
const Ent = () => import("@/pages/EntManagenment/entList");
const Employee = () => import("@/pages/EntManagenment/employee/list");
const Post = () => import("@/pages/EntManagenment/post/list");
const Job = () => import("@/pages/EntManagenment/job/list");
const RiskUnit = () => import("@/pages/RiskManagement/riskUnit");
const publicRiskUnit = () => import("@/pages/RiskManagement/publicRiskUnit");
const RiskPosition = () => import("@/pages/RiskManagement/riskPosition");
const RiskControl = () => import("@/pages/RiskManagement/riskControl");
const pesrsonRiskControl = () => import("@/pages/RiskManagement/pesrsonRiskControl");

const BasicInfo = () => import("@/pages/Hidden/basicInfo");
const HRepository = () => import("@/pages/Hidden/checkList/repository");
const CheckList = () => import("@/pages/Hidden/check/list");
const CheckAdd = () => import("@/pages/Hidden/check/add");
const Relevant = () => import("@/pages/thirdParty/relevant/relevantRoster");
const HaveDone = () => import("@/pages/Backlog/haveDone");
const Version = () => import("@/pages/baseinfo/version/list");
const Operlog = () => import("@/pages/baseinfo/operlog/list");
const ApprovalList = () => import("@/pages/Hidden/check/approvalList");
const RiskEventType = () => import("@/pages/RiskManagement/riskEventType");

const WorkPlaceManage = () => import("@/pages/EntManagenment/od/workPlaceManage");
const TouchHarmStation = () => import("@/pages/EntManagenment/od/touchHarmStation");
const DiseaseTreatment = () => import("@/pages/EntManagenment/od/diseaseTreatment");
const HealthSummary = () => import("@/pages/EntManagenment/od/healthSummary");
const LawList = () => import("@/pages/knowledgeBase/law/list");
const SubList = () => import("@/pages/knowledgeBase/law/subList");
const RulesTypeList = () => import("@/pages/knowledgeBase/rules/rulesTypeList");
const RulesList = () => import("@/pages/knowledgeBase/rules/list");
const SeTargetNameList = () => import("@/pages/security/target/list");
const SeTargetList = () => import("@/pages/security/target/needList");
const SeNextList = () => import("@/pages/security/target/nextList");
const appraisal = () => import("@/pages/appraisal/list");
const EReportList = () => import("@/pages/ereport/list");
const EReportChartList = () => import("@/pages/ereport/chart");
const ExpertList = () => import("@/pages/emergency/expert/list");
const MaterialList = () => import("@/pages/emergency/materials/list");
const TeamList = () => import("@/pages/emergency/team/list");
const DrillPlanList = () => import("@/pages/emergency/drillplan/list");
const EntAttList = () => import("@/pages/EntManagenment/att/list");
const StandardList = () => import("@/pages/security/industry/stalist");
const IndustryList = () => import("@/pages/security/industry/qualist");
const DrillList = () => import("@/pages/emergency/drill/list");
const DutyEmployeeList = () => import("@/pages/emergency/dutyemployee/list");
const operations = () => import("@/pages/operations/main");
const ProList = () => import("@/pages/proManagenment/pro/proList");
const HarmfulType = () => import("@/pages/EntManagenment/od/harmfulType");
const HarmfulBigType = () => import("@/pages/EntManagenment/od/harmfulBigType");
const workFactor = () => import("@/pages/EntManagenment/od/workFactor");
const hazardFactor = () => import("@/pages/EntManagenment/od/hazardFactor");
const fireControl = () => import("@/pages/EntManagenment/od/fireControl");
const fireControlInput = () => import("@/pages/EntManagenment/od/fireControlInput");
const fireHouse = () => import("@/pages/EntManagenment/od/fireHouse");
const sending = () => import("@/pages/EntManagenment/od/sending");
const instructions = () => import("@/pages/EntManagenment/od/instructions");
const handle = () => import("@/pages/EntManagenment/od/handle");

const HarmfulFactor = () => import("@/pages/EntManagenment/od/harmfulFactor");
const HealthExamination = () => import("@/pages/EntManagenment/professional/healthExamination");
const ProtectAgainstRegulation = () => import("@/pages/EntManagenment/od/protectAgainstRegulation")
const ProtectiveEquipmentBasic = () => import("@/pages/EntManagenment/labour/protectiveEquipmentBasic");
const DictionaryList = () => import("@/pages/security/dictionary/list");
const BaseConfig = () => import("@/pages/security/baseconfig/list");
const TypeDictionaryList = () => import("@/pages/security/typeDictionary/list");
const Course = () => import("@/pages/training/course");
import newRouter from "./newRouter";


// 预警模板设置
const AlertComp=()=>import("@/pages/alertmanagment/AlertComp")

//清单式隐患排查流程  改为隐患计划
const listHiddenCheckList = () => import("@/pages/Hidden/listHiddenCheck/list");

const checkSelfList = () => import("@/pages/Hidden/listHiddenCheck/checkSelfList");

const hiddenRectification = () => import("@/pages/Hidden/hiddenrectification/list");

const hiddenHandle = () => import("@/pages/Hidden/hiddenHandle/list");

const hiddenRecord = () => import("@/pages/Hidden/hiddenRecord/list");

const checkSelf = () => import("@/pages/Hidden/listHiddenCheck/checkSelf");


//迎检计划
const ListWelcomeInspection = () => import("@/pages/welcomeInspection/list");
// 迎检结果
const ResultWelcomeInspection = () => import("@/pages/welcomeInspection/result");
// 整改情况
const RectifyWelcomeInspection = () => import("@/pages/welcomeInspection/rectify");
// 问题验收
const AcceptWelcomeInspection = () => import("@/pages/welcomeInspection/accept");
// 汇总报表
const ResultReport = () => import("@/pages/welcomeInspection/resultReport");
//安全环保
const factorMaintain = () => import("@/pages/EnvironmentalProtection/factorMaintain")
const factorManage = () => import("@/pages/EnvironmentalProtection/factorManage")
const outfall = () => import("@/pages/EnvironmentalProtection/outfall")
const radiate = () => import("@/pages/EnvironmentalProtection/epRadiateInformation")
const epfacilities = () => import("@/pages/EnvironmentalProtection/epfacilities")
const manualMonitor = () => import("@/pages/EnvironmentalProtection/epManualMonitor")
// const rainage = () => import("@/pages/EnvironmentalProtection/epRainage")
const discharge = () => import("@/pages/EnvironmentalProtection/discharge");
const concentration = () => import("@/pages/EnvironmentalProtection/concentration");
const hourCollDay = () => import("@/pages/EnvironmentalProtection/enCollHourDay");

const warningset = () => import("@/pages/warningset/list");
// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = resolve => require(["@/components/Login"], resolve);
// const Login = resolve => require(['@/components/Datastatic3'], resolve)

Vue.use(Router);

let router = new Router({
  mode: "history",
  //base: '/dist',
  routes: [
    {
      path: "/Login",
      name: "登录",
      component: Login
    },
    {
      path: "/datastatic",
      name: "数据看板",
      component: () => import("@/components/Datastatic")
    },
    {
      path: "/operationSupervision",
      name: "作业一张图",
      component: () => import("@/components/operationSupervision")
    },
    {
      path: "/monitoringAlarm",
      name: "AI预警管控",
      component: () => import("@/components/monitoringAlarm")
    },
    {
      path: "/datastatic3",
      name: "集团看板",
      component: () => import("@/components/Datastatic3")
    },
    {
      path: "/tsrlWelcome",
      name: "集团看板",
      component: () => import("@/components/tsrlWelcome")
    },
    {
      path: "/videoSurveillance",
      name: "视频监控",
      component: () => import("@/components/VideoSurveillance")
    },
    {
      path: "/workConditionMap",
      name: "环保总览",
      component: () => import("@/components/EnvProDatastatic"),
    },
    {
      path: "/envProDcsDatastatic",
      name: "环保DCS",
      component: () => import("@/components/EnvProDcsDatastatic"),
    },
    {
      path: "/gassAlarm",
      name: "煤气一张图",
      component: () => import("@/components/GassAlarm"),
    },
    {
      path: "/workCertificatePreview_LIMIT",
      name: "受限空间作业证预览",
      component: () => import("@/components/common/examine/printPage/printLimitPage")
    },
    {
      path: "/workCertificateBookPreview_LIMIT",
      name: "受限空间告知书预览",
      component: () => import("@/components/common/examine/printPage/printBookLimitPage")
    },
    {
      path: "/workCertificatePreview_FIRE",
      name: "动火作业证预览",
      component: () => import("@/components/common/examine/printPage/printFirePage")
    },
    {
      path: "/workCertificateBookPreview_FIRE",
      name: "动火作业告知书预览",
      component: () => import("@/components/common/examine/printPage/printBookFirePage")
    },
    {
      path: "/workCertificatePreview_HIGH",
      name: "高处安全作业证预览",
      component: () => import("@/components/common/examine/printPage/printHighPage")
    },
    {
      path: "/workCertificateBookPreview_HIGH",
      name: "高处作业告知书预览",
      component: () => import("@/components/common/examine/printPage/printBookHighPage")
    },
    {
      path: "/workCertificatePreview_LIFT",
      name: "吊装安全作业证预览",
      component: () => import("@/components/common/examine/printPage/printLiftPage")
    },
    {
      path: "/workCertificateBookPreview_LIFT",
      name: "吊装作业告知书预览",
      component: () => import("@/components/common/examine/printPage/printBookLiftPage")
    },
    {
      path: "/workCertificatePreview_TEMP",
      name: "临时用电安全作业证预览",
      component: () => import("@/components/common/examine/printPage/printTempPage")
    },
    {
      path: "/workCertificateBookPreview_TEMP",
      name: "临时用电告知书预览",
      component: () => import("@/components/common/examine/printPage/printBookTempPage")
    },
    {
      path: "/workCertificatePreview_GROUND",
      name: "动土安全作业作业证预览",
      component: () => import("@/components/common/examine/printPage/printGroundPage")
    },
    {
      path: "/workCertificatePreview_BLIND",
      name: "盲板抽堵安全作业证预览",
      component: () => import("@/components/common/examine/printPage/printBlindPage")
    },
    {
      path: "/workCertificatePreview_BROKEN",
      name: "断路安全作业证预览",
      component: () => import("@/components/common/examine/printPage/printBrokenPage")
    }
    ,
    {
      path: "/workCertificatePreview_Audit",
      name: "危险作业审批表预览",
      component: () => import("@/components/common/examine/printPage/printAuditPage")
    },
    {
      path: "/workCertificateBookPreview_Audit",
      name: "风险告知卡预览",
      component: () => import("@/components/common/examine/printPage/printBookAuditPage")
    },
    {
      path: "/workCertificatePreview_hyMeeting",
      name: "班前会记录预览",
      component: () => import("@/pages/preShiftMeeting/priview")
    },
    {
      path: "/workCertificatePreview_GC",
      name: "外包工程作业票预览",
      component: () => import("@/components/common/examine/printPage/printEngineeringPage")
    },
    {
      path: "/workCertificatePreview_printHealthPromisePage",
      name: "健康承诺表预览",
      component: () => import("@/components/common/examine/printPage/printHealthPromisePage.vue")
    },
    {
      path: "/workCertificatePreview_bind",
      name: "用户绑定公众号",
      component: () => import("@/components/common/examine/printPage/bindPage")
    },
    {
      path: "/workCertificatePreview_MQZY",
      name: "煤气停送作业票预览",
      component: () => import("@/components/common/examine/printPage/printGasPage")
    },
    {
      path: "/workCertificatePreview_printGasOperatePage",
      name: "煤气操作票预览",
      component: () => import("@/components/common/examine/printPage/printGasOperatePage")
    },
    {
      path: "/workCertificatePreview_SchemePage",
      name: "高风险检修方案预览",
      component: () => import("@/components/common/examine/printPage/printSchemePage")
    },

    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home,
    //   redirect: '/dashboard',
    //   leaf: true, // 只有一个节点
    //   menuShow: true,
    //   iconCls: 'fa fa-home', // 图标样式class
    //   children: [
    //     {path: '/dashboard', component: Dashboard, name: '首页', menuShow: true}
    //   ]
    // },
    {
      path: "/",
      name: "home",
      component: Home,
      redirect: "/dashboard",
      leaf: true, // 只有一个节点
      menuShow: true,
      iconCls: "fa fa-home", // 图标样式class
      children: [
        {
          path: "/dashboard",
          component: Dashboard,
          name: "首页",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "用户管理",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/admin/user",
          component: UserList,
          name: "用户列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "流程管理",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/activiti/manager",
          component: resolve =>
            require(["@/pages/activiti/activitiManager.vue"], resolve),
          name: "流程绑定",
          menuShow: true
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "菜单管理",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-server", // 图标样式class
      children: [
        {
          path: "/admin/menu",
          component: MenuList,
          name: "菜单列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "应急管理",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-server", // 图标样式class
      children: [
        {
          path: "/emergency/expert",
          component: ExpertList,
          name: "应急专家",
          menuShow: true
        },
        {
          path: "/emergency/materials",
          component: MaterialList,
          name: "应急物资",
          menuShow: true
        },
        {
          path: "/emergency/team",
          component: TeamList,
          name: "应急队伍",
          menuShow: true
        },
        {
          path: "/emergency/drillplan",
          component: DrillPlanList,
          name: "演练计划",
          menuShow: true
        },
        {
          path: "/emergency/drill",
          component: DrillList,
          name: "应急演练",
          menuShow: true
        },
        {
          path: "/emergency/dutyemployee",
          component: DutyEmployeeList,
          name: "应急值守人员",
          menuShow: true
        },
        {
          path: "/emergency/dutyevent",
          component: resolve =>
            require(["@/pages/emergency/dutyemployee/dutyevent"], resolve),
          name: "值班排班",
          menuShow: true
        },
        {
          path: "/emergency/emanagement",
          component: resolve =>
            require(["@/pages/emergency/emanagement/list"], resolve),
          name: "应急预案",
          menuShow: true
        },
        {
          path: "/emergency/eventdeal",
          component: resolve =>
            require(["@/pages/emergency/emanagement/eventlist"], resolve),
          name: "应急事件处理",
          menuShow: true
        },
        {
          path: "/emergency/fireEquipment",
          component: resolve =>
            require(["@/pages/emergency/fireEquipment/fireEquipment"], resolve),
          name: "消防设施",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "角色管理",
      menuShow: true,
      leaf: true,
      iconCls: "fa fa-group",
      children: [
        {
          path: "/admin/role",
          component: BookList,
          name: "角色列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "报表管理",
      menuShow: true,
      leaf: true,
      iconCls: "fa fa-group",
      children: [
        {
          path: "/admin/chart/list",
          component: ChartsConfList,
          name: "报表列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "设置",
      menuShow: true,
      iconCls: "iconfont icon-setting1",
      children: [
        {
          path: "/user/profile",
          component: UserProfile,
          name: "个人信息1",
          menuShow: true
        },
        {
          path: "/user/changepwd",
          component: UserChangePwd,
          name: "修改密码",
          menuShow: true
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "注册服务",
      menuShow: true,
      iconCls: "iconfont icon-setting1",
      children: [
        {
          path: "/service",
          component: UserProfile,
          redirect: "http://baidu.com",
          target: "_blank",
          name: "注册服务列表",
          menuShow: true
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "部门管理菜单",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/department",
          component: Department,
          name: "部门管理",
          menuShow: true
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "企业管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/ent",
          component: Ent,
          name: "企业基本信息",
          menuShow: true
        },
        {
          path: "/eFilingManagement",
          component:
            resolve => require(["@/pages/EntManagenment/EFilingManagement"], resolve),
          name: "备案管理模块",
          menuShow: true
        },
        {
          path: "/custommenu",
          component: Custommenu,
          name: "菜单订制",
          menuShow: true
        },
        {
          path: "/smsmanger",
          component: Smsmanger,
          name: "短信管理",
          menuShow: true
        },
        {
          path: "/appraisal",
          component: appraisal,
          name: "绩效考核",
          menuShow: true
        },
        {
          path: "/exportFileList",
          component: resolve => require(["@/pages/exportFile/list"], resolve),
          name: "导出文件列表",
          menuShow: true
        },
        {
          path: "/employee",
          component: Employee,
          name: "员工管理",
          menuShow: true
        },
        {
          path: "/warningset",
          component: warningset,
          name: "预警设置",
          menuShow: true
        },
        {
          path: "/diseasesType",
          component: resolve =>
            require(["@/pages/EntManagenment/od/diseasesType"], resolve),
          name: "职业病种类管理",
          menuShow: true
        },
        {
          path: "/workPlaceManage",
          component: WorkPlaceManage,
          name: "工作场所管理",
          menuShow: true
        },
        {
          path: "/touchHarmStation",
          component: TouchHarmStation,
          name: "接害岗位备案",
          menuShow: true
        },
        {
          path: "/diseaseTreatment",
          component: DiseaseTreatment,
          name: "职业病诊疗档案",
          menuShow: true
        },
        {
          path: "/healthSummary",
          component: HealthSummary,
          name:"职业健康汇总",
          menuShow: true
        },
        {
          path: "/healthCustodyPerson",
          component: resolve =>
            require(["@/pages/EntManagenment/od/healthCustodyPerson"], resolve),
          name: "个人监护档案",
          menuShow: true
        },
        {
          path: "/healthMedicalRecord",
          component: resolve =>
            require(["@/pages/EntManagenment/od/healthMedicalRecord"], resolve),
          name: "既往病史管理",
          menuShow: true
        },
        {
          path: "/healthMedicalHistory",
          component: resolve =>
            require(["@/pages/EntManagenment/od/healthMedicalHistory"], resolve),
          name: "职业病史管理",
          menuShow: true
        },
        {
          path: "/healthContactHistory",
          component: resolve =>
            require(["@/pages/EntManagenment/od/healthContactHistory"], resolve),
          name: "职业病危害接触史管理",
          menuShow: true
        },
        {
          path: "/erule/list",
          component: resolve => require(["@/pages/erule/main"], resolve),
          name: "规章制度",
          menuShow: true
        },
        {
          path: "/harmfulDiscern",
          component: resolve =>
            require(["@/pages/EntManagenment/od/harmfulDiscern"], resolve),
          name: "职业病危害因素识别",
          menuShow: true
        },
        {
          path: "/typeOfWork",
          component: resolve =>
            require(["@/pages/EntManagenment/typeOfWork/typeOfWork"], resolve),
          name: "岗位管理",
          menuShow: true
        },
        {
          path: "/exposedPerson",
          component: resolve =>
            require(["@/pages/EntManagenment/od/exposedPerson"], resolve),
          name: "职业危害人员",
          menuShow: true
        },
        {
          path: "/organization",
          component: resolve => require(["@/pages/organization/list"], resolve),
          name: "机构管理",
          menuShow: true
        },
        {
          path: "/organization/user",
          component: resolve =>
            require(["@/pages/organization/organizationuserlist"], resolve),
          name: "机构人员管理",
          menuShow: true
        },
        {
          path: "/eTypeDictionary/list",
          component: resolve =>
            require(["@/pages/security/typeDictionary/eList"], resolve),
          name: "企业类型管理",
          menuShow: true
        },
        {
          path: "/eRegulations/list",
          component: resolve =>
            require(["@/pages/security/regulations/main"], resolve),
          name: "操作规程",
          menuShow: true
        },
        {
          path: "/bounded/list",
          component: resolve =>
            require(["@/pages/security/bounded/list"], resolve),
          name: "有（受）限空间管理",
          menuShow: true
        },
        {
          path: "/testing/list",
          component: resolve =>
            require(["@/pages/security/testing/list"], resolve),
          name: "第三方检测",
          menuShow: true
        },
        {
          path: "/assessment/list",
          component: resolve =>
            require(["@/pages/security/assessment/list"], resolve),
          name: "第三方评估",
          menuShow: true
        },
        {
          path: "/dust/list",
          component: resolve =>
            require(["@/pages/security/dust/list"], resolve),
          name: "粉尘涉爆",
          menuShow: true
        },
        {
          path: "/messageNotification/message",
          component: resolve =>
            require([
              "@/pages/EntManagenment/messageNotification/message"
            ], resolve),
          name: "消息通知",
          menuShow: true
        },
        {
          path: "/messageNotification/notify",
          component: resolve =>
            require([
              "@/pages/EntManagenment/messageNotification/notify"
            ], resolve),
          name: "通知下发",
          menuShow: true
        },
        {
          path: "/videoDevice/videoConfig",
          component: resolve =>
            require([
              "@/pages/EntManagenment/videoDevice/videoConfig"
            ], resolve),
          name: "视频配置",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "制度化建设",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/complainceComment",
          component: resolve =>
            require(["@/pages/complainceComment/complainceComment"], resolve),
          name: "合规性评价",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "消防巡查",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/fireCheckCfg",
          component: resolve =>
            require(["@/pages/EntManagenment/od/fireCheckConfig"], resolve),
          name: "巡查项目",
          menuShow: true
        },
        {
          path: "/fireCheckpoint",
          component: resolve =>
            require(["@/pages/EntManagenment/od/fireCheckPoint"], resolve),
          name: "消防巡查点",
          menuShow: true
        },
        {
          path: "/fireInspect",
          component: resolve =>
            require(["@/pages/EntManagenment/od/fireInspect"], resolve),
          name: "消防巡查记录表",
          menuShow: true
        },
        {
          path: "/fireMaintain",
          component: resolve =>
            require(["@/pages/EntManagenment/od/fireMaintain"], resolve),
          name: "消防维保记录",
          menuShow: true
        },
      ]
    },
    {
      path: "/",
      component: Home,
      name: "职业健康管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/harmfulType",
          component: HarmfulType,
          name: "职业病危害类型管理",
          menuShow: true
        },
        {
          path: "/harmfulBigType",
          component: HarmfulBigType,
          name: "职业病大类管理",
          menuShow: true
        },
        {
          path: "/workFactor",
          component: workFactor,
          name: "工作场所危害因素",
          menuShow: true
        },


        {
          path: "/hazardFactor",
          component: hazardFactor,
          name: "工作场所危害因素检测",
          menuShow: true
        },
        {
          path: "/fireControl",
          component: fireControl,
          name: "消防台账",
          menuShow: true
        },
        {
          path: "/fireHouse",
          component: fireHouse,
          name: "消防站配置",
          menuShow: true
        },
        {
          path: "/fireControlInput",
          component: fireControlInput,
          name: "消防器材点检记录",
          menuShow: true
        },
        {
          path: "/sending",
          component: sending,
          name: "来文登记",
          menuShow: true
        },
        {
          path: "/instructions",
          component: instructions,
          name: "来文登记",
          menuShow: true
        },
        {
          path: "/handle",
          component: handle,
          name: "来文办理",
          menuShow: true
        },
        {
          path: "/harmfulFactor",
          component: HarmfulFactor,
          name: "职业病危害因素管理",
          menuShow: true
        },
        {
          path: "/healthExamination",
          component: HealthExamination,
          name: "职业健康检查管理",
          menuShow: true
        },
        {
          path: "/protectAgainstRegulation",
          component: ProtectAgainstRegulation,
          name: "防护违章情况",
          menuShow: true
        },
        {
          path: "/protectiveEquipmentBasic",
          component: ProtectiveEquipmentBasic,
          name: "劳动防护用品基础信息管理",
          menuShow: true
        },
        {
          path: "/protectiveEquipmentRecord",
          component: resolve =>
            require([
              "@/pages/EntManagenment/labour/protectiveEquipmentRecord"
            ], resolve),
          name: "劳动防护用品发放管理",
          menuShow: true
        },
        {
          path: "/protectiveEquipmentReport",
          component: resolve =>
            require([
              "@/pages/EntManagenment/labour/protectiveEquipmentReport"
            ], resolve),
          name: "劳保用品统计报表",
          menuShow: true
        },
        {
          path: "/healthPromiseBook",
          component: resolve => require(['@/pages/healthPromiseBook/add.vue'], resolve),
          name: "健康承诺书",
          menuShow: true
        },
        {
          path: "/workAreaConfirm",
          component: resolve => require(['@/pages/healthPromiseBook/workAreaConfirm.vue'], resolve),
          name: "作业区确认",
          menuShow: true
        },
        {
          path: "/deptLeaderConfirm",
          component: resolve => require(['@/pages/healthPromiseBook/deptLeaderConfirm.vue'], resolve),
          name: "部门确认",
          menuShow: true
        },
        {
          path: "/laborProtection/lpCfg",
          component: resolve => require(['@/pages/laborProtection/lpCfg.vue'], resolve),
          name: "劳保配置清单",
          menuShow: true
        },
        {
          path: "/laborProtection/personLp",
          component: resolve => require(['@/pages/laborProtection/personLp.vue'], resolve),
          name: "个人劳保卡",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "涉危情况管理",
      menuShow: true,
      leaf: true,
      children: []
    },
    {
      path: "/",
      component: Home,
      name: "ereport",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/ereport",
          component: EReportList,
          name: "事件上报",
          menuShow: true
        },
        {
          path: "/ereportAudit",
          component: resolve => require(["@/pages/ereportAudit/list"], resolve),
          name: "事件上报审核",
          menuShow: true
        },
        {
          path: "/chart",
          component: EReportChartList,
          name: "事件展示",
          menuShow: true
        },
        {
          path: "/reportDistribute",
          component: resolve => require(["@/pages/ereport/reportDistribute.vue"], resolve),
          name: "事件派发",
          menuShow: true
        },
        {
          path: "/reportRectification",
          component: resolve => require(["@/pages/ereport/reportRectification.vue"], resolve),
          name: "事件整改",
          menuShow: true
        },
      ]
    },

    /*{
      path: '/',
      component: Home,
      name: 'employee manager',
      menuShow: true,
      leaf: true,
      children: [
        {path: '/employee', component: Employee, name: '员工管理', menuShow: true},
      ]
    },*/
    {
      path: "/",
      component: Home,
      name: "post manager",
      menuShow: true,
      leaf: true,
      children: [
        { path: "/post", component: Post, name: "职务管理", menuShow: true }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "job manager",
      menuShow: true,
      leaf: true,
      children: [
        { path: "/job", component: Job, name: "岗位管理", menuShow: true }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "riskManagement public",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/publicRiskUnit",
          component: publicRiskUnit,
          name: "行业公有风险单元",
          menuShow: true
        },
        {
          path: "/base/basicInfo",
          component: resolve => require(["@/pages/Hidden/base/basicInfo"], resolve),
          name: "隐患基础信息管理",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "Relevant",
      menuShow: true,
      leaf: true,
      children: []
    },
    {
      path: "/",
      component: Home,
      name: "车辆管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/ecar",
          component: resolve => require(["@/pages/ecar/list"], resolve),
          name: "车辆登记",
          menuShow: true
        },
        {
          path: "/ecar/use",
          component: resolve => require(["@/pages/ecar/use"], resolve),
          name: "车辆派单",
          menuShow: true
        },
        {
          path: "/ecar/repair",
          component: resolve => require(["@/pages/ecar/repair"], resolve),
          name: "车辆保险",
          menuShow: true
        },
        {
          path: "/ecar/inspection",
          component: resolve => require(["@/pages/ecar/inspection"], resolve),
          name: "车辆维修",
          menuShow: true
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "inspection",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/basicInfo",
          component: BasicInfo,
          name: "隐患基础信息管理",
          menuShow: true
        },
        {
          path: "/hrepository",
          component: HRepository,
          name: "隐患库管理",
          menuShow: true
        },
        {
          path: "/checkList/addFlow",
          component: resolve =>
            require(["@/pages/Hidden/checkList/listCheckAdd"], resolve),
          name: "listCheckAdd",
          menuShow: true
        },
        {
          path: "/hidden/list",
          component: resolve => require(["@/pages/Hidden/list"], resolve),
          name: "隐患查询列表",
          menuShow: true
        },
        {
          path: "/check/list",
          component: CheckList,
          name: "排查列表",
          menuShow: true
        },
        {
          path: "/checkTabList",
          component: resolve =>
            require(["@/pages/Hidden/checkList/tabList"], resolve),
          name: "制定检查表",
          menuShow: true
        },
        {
          path: "/checkList",
          component: resolve =>
            require(["@/pages/Hidden/checkList/list"], resolve),
          name: "隐患单管理",
          menuShow: true
        },
        {
          path: "/hiddenCheckList",
          component: listHiddenCheckList,
          name: "隐患单排查",
          menuShow: true
        },
        {
          path: "/checkSelfList",
          component: checkSelfList,
          name: "自检自查",
          menuShow: true
        },
        {
          path: "/checkSelf",
          component: checkSelf,
          name: "自检自查",
          menuShow: true
        },
        {
          path: "/hiddenHandle",
          component: hiddenHandle,
          name: "隐患处理",
          menuShow: true
        },
        {
          path: "/hiddenRecord",
          component: hiddenRecord,
          name: "排查记录查询",
          menuShow: true
        },
        {
          path: "/hiddenApprove",
          component: resolve =>
            require(["@/pages/Hidden/hiddenApprove/list"], resolve),
          name: "隐患排查确认",
          menuShow: true
        },
        {
          path: "/listHiddenRectification",
          component: hiddenRectification,
          name: "隐患整改",
          menuShow: true
        },
        {
          path: "/check/add",
          component: CheckAdd,
          name: "排查新增",
          menuShow: true
        },
        {
          path: "/picture/hiddenAudit",
          component: resolve =>
            require(["@/pages/handPicture/task/pictureHiddenAudit"], resolve),
          name: "随手拍审核",
          menuShow: true
        },
        {
          path: "/picture/hiddenPub",
          component: resolve => require(["@/pages/Hidden/hiddenPub/addView"], resolve),
          name: "随手拍公共上报组件",
          menuShow: true
        },
        {
          path: "/abar/abarbeitung",
          component: resolve =>
            require(["@/pages/Hidden/abar/abarbeitung"], resolve),
          name: "abarbeitung",
          menuShow: true
        },
        {
          path: "/hiddenAudit/detail",
          component: resolve =>
            require(["@/pages/Hidden/hiddenAudit/detail"], resolve),
          name: "hiddenAuditDetail",
          menuShow: true
        },
        {
          path: "/review/review",
          component: resolve =>
            require(["@/pages/Hidden/review/review"], resolve),
          name: "review",
          menuShow: true
        },
        {
          path: "/review/detail",
          component: resolve =>
            require(["@/pages/Hidden/review/detail"], resolve),
          name: "/review/detail",
          menuShow: true
        },
        {
          path: "/review/reviewaudit",
          component: resolve =>
            require(["@/pages/Hidden/review/reviewaudit"], resolve),
          name: "reviewaudit",
          menuShow: true
        },
        {
          path: "/MajorHazard/MajorHazard",
          component: resolve =>
            require(["@/pages/Hidden/MajorHazard/MajorHazard"], resolve),
          name: "MajorHazard",
          menuShow: true
        },
        {
          path: "/report/reportEdit",
          component: resolve =>
            require(["@/pages/Hidden/check/reportEdit"], resolve),
          name: "ReportEdit",
          menuShow: true
        },
        {
          path: "/sisetu",
          component: resolve => require(["@/pages/Hidden/sisetu"], resolve),
          name: "四色图",
          menuShow: true
        },
        {
          path: "/fourColorMap",
          component: resolve => require(["@/pages/fourColorMap/fourColorMap"], resolve),
          name: "新四色图",
          menuShow: true
        },
        // {
        //   path: "/workConditionMap",
        //   component: resolve => require(["@/components/EnvProDatastatic"], resolve),
        //   name: "工况总览",
        //   menuShow: true
        // },
        {
          path: "/handPicture/list",
          component: resolve => require(["@/pages/handPicture/list"], resolve),
          name: "随手拍",
          menuShow: true
        },
      ]
    },
    {
      path: "/",
      component: Home,
      name: "backlog",
      menuShow: true,
      leaf: false,
      children: [
        {
          path: "/backlog",
          component: resolve => require(["@/pages/Backlog/backlog"], resolve),
          name: "待办事项",
          menuShow: true,
          leaf: true
        },
        {
          path: "/sysRunCheck",
          component: resolve => require(["@/pages/sysRunCheck/list"], resolve),
          name: "预警管理",
          menuShow: true,
          leaf: true
        },
        {
          path: "/analyzeList",
          component: resolve => require(["@/pages/sysRunCheck/analyzeList"], resolve),
          name: "预警分析",
          menuShow: true,
          leaf: true
        },
        {
          path: "/relevant/payconfirm",
          component: resolve => require(["@/pages/sysRunCheck/relPay"], resolve),
          name: "外包单位缴费确认",
          menuShow: true,
          leaf: true
        },
        {
          path: "/haveDone",
          component: HaveDone,
          name: "已办事项",
          menuShow: true,
          leaf: false
        },
        {
          path:"/crew",
          component: resolve => require(["@/pages/preShiftMeeting/crew"], resolve),
          name: "作业区班组成员",
          menuShow: true,
          leaf: true
        },
        {
          path:"/supervise",
          component: resolve => require(["@/pages/preShiftMeeting/supervise"], resolve),
          name: "班前会监管人员",
          menuShow: true,
          leaf: true
        },
        {
          path:"/ledge",
          component: resolve => require(["@/pages/preShiftMeeting/ledge"], resolve),
          name: "班前会记录",
          menuShow: true,
          leaf: true
        },
        {
          path: "/preShiftMeeting/meetingRecord",
          component: resolve =>
            require(["@/pages/preShiftMeeting/meetingRecord"], resolve),
          name: "会议记录表",
          menuShow: true,
          leaf: true
        },
        {
          path: "/dayMeet",
          component: resolve =>
            require(["@/pages/preShiftMeeting/dayMeet"], resolve),
          name: "日会议预警表",
          menuShow: true,
          leaf: true
        },
        {
          path: "/monthlyMeet",
          component: resolve =>
            require(["@/pages/preShiftMeeting/monthlyMeet"], resolve),
          name: "月度会议汇总表",
          menuShow: true,
          leaf: true
        },
        {
          path: "/preShiftMeeting/check/:type",
          component: resolve => require(["@/pages/thirdParty/rel/check"], resolve),
          name: "班组检查内容",
          menuShow: true,
          leaf: true
        },
        {
          path: "/inspect",
          component: resolve => require(["@/pages/preShiftMeeting/inspect"], resolve),
          name: "班组安全检查记录表",
          menuShow: true,
          leaf: true
        },


        {
          path: "/operationLog",
          component: resolve =>
            require(["@/pages/sms/operationLog"], resolve),
          name: "系统操作记录",
          menuShow: true,
          leaf: true
        },

      ]
    },
    {
      path: "/",
      component: Home,
      name: "riskPosition",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/riskPosition",
          component: RiskPosition,
          name: "风险点位置",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "operlog",
      menuShow: true,
      leaf: true,
      children: [
        { path: "/Operlog", component: Operlog, name: "操作日志", menuShow: true }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "version",
      menuShow: true,
      leaf: true,
      children: [
        { path: "/version", component: Version, name: "版本号", menuShow: true }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "approvalList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/approvalList",
          component: ApprovalList,
          name: "审批",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "风险管控",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/riskControl",
          component: RiskControl,
          name: "风险分级管控",
          menuShow: true
        },
        {
          path: "/pesrsonRiskControl",
          component: pesrsonRiskControl,
          name: "风险清单",
          menuShow: true
        },

        {
          path: "/riskControlExport",
          component: resolve =>
            require(["@/pages/RiskManagement/riskControlExport"], resolve),
          name: "风险巡查统计",
          menuShow: true
        },
        {
          path: "/safetySignsType",
          component: resolve =>
            require(["@/pages/security/safetySignsType/list"], resolve),
          name: "安全标志类型管理",
          menuShow: true
        },
        {
          path: "/safetySigns",
          component: resolve =>
            require(["@/pages/security/safetySigns/list"], resolve),
          name: "安全标志管理",
          menuShow: true
        },
        {
          path: "/riskUnit",
          component: RiskUnit,
          name: "风险单元",
          menuShow: true
        },
        {
          path: "/riskControlCalerdar",
          component: resolve =>
            require(["@/pages/RiskManagement/riskControlCalerdar"], resolve),
          name: "风险管控日历",
          menuShow: true
        },
        {
          path: "/riskEventType",
          component: RiskEventType,
          name: "企业事故类型管理",
          menuShow: true
        },
        {
          path: "/personnelPatrol",
          component: resolve =>
            require(["@/pages/RiskManagement/riskPersonnelPatrol"], resolve),
          name: "人员巡查情况",
          menuShow: true
        },
        {
          path: "/riskPatrol",
          component: resolve =>
            require(["@/pages/RiskManagement/riskPatrol"], resolve),
          name: "风险点巡查情况",
          menuShow: true
        },
        {
          path: "/riskControlInfo",
          component: resolve =>
            require(["@/pages/RiskManagement/riskControlInfo"], resolve),
          name: "风险管控信息",
          menuShow: true
        },
        {
          path: "/riskPatrolTaskList",
          component: resolve =>
            require(["@/pages/RiskManagement/riskPatrolTaskList"], resolve),
          name: "巡查任务清单",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "安全管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/safescore/stand",
          component: resolve =>
            require(["@/pages/enterpriseFile/safescore/stand"], resolve),
          name: "安全记分标准",
          menuShow: true
        },
        {
          path: "/safescore/type",
          component: resolve =>
            require(["@/pages/enterpriseFile/safescore/type"], resolve),
          name: "安全记分类型",
          menuShow: true
        },
        {
          path: "/safescore/report",
          component: resolve =>
            require(["@/pages/enterpriseFile/safescore/report"], resolve),
          name: "安全记分上报",
          menuShow: true
        },
        {
          path: "/safescore/scAudit",
          component: resolve =>
            require(["@/pages/enterpriseFile/safescore/road/scReportAudit"], resolve),
          name: "安全记分上报审核",
          menuShow: true
        },
        {
          path: "/safescore/scAuditFinal",
          component: resolve =>
            require(["@/pages/enterpriseFile/safescore/road/scReportFinal"], resolve),
          name: "安全记分上报提级审批",
          menuShow: true
        },
        {
          path: "/safescore/ledger",
          component: resolve =>
            require(["@/pages/enterpriseFile/safescore/ledger"], resolve),
          name: "安全记分台账",
          menuShow: true
        },
        {
          path: "/meetingCommittee",
          component: resolve =>
            require(["@/pages/security/meetingCommittee/list"], resolve),
          name: "安委会、例会",
          menuShow: true
        },
        {
          path: "/meetingClass",
          component: resolve =>
            require(["@/pages/security/meetingClass/list"], resolve),
          name: "班委会",
          menuShow: true
        },
        {
          path: "/securityMeeting",
          component: resolve =>
            require(["@/pages/security/securityMeeting/meetingList"], resolve),
          name: "安全会议",
          menuShow: true
        },
        {
          path: "/hazardSources/list",
          component: resolve =>
            require(["@/pages/security/hazardSources/list"], resolve),
          name: "重大危险源",
          menuShow: true
        },
        {
          path: "/devicesKeyparts/list",
          component: resolve =>
            require(["@/pages/security/devicesKeyparts/list"], resolve),
          name: "关键装置和重点部位",
          menuShow: true
        },
        {
          path: "/danger/list",
          component: resolve =>
            require(["@/pages/security/danger/list"], resolve),
          name: "危险化工工艺",
          menuShow: true
        },
        {
          path: "/blame/blameList",
          component: resolve =>
            require(["@/pages/security/blame/blameList"], resolve),
          name: "追责问责清单",
          menuShow: true
        },

        {
          path: "/endangeredProduct",
          component: resolve =>
            require(["@/pages/EntManagenment/endangered/product"], resolve),
          name: "涉危产品管理",
          menuShow: true
        },
        {
          path: "/enterprise/hazardousmaterials/list",
          component: resolve =>
            require([
              "@/pages/EntManagenment/hazardousmaterials/list"
            ], resolve),
          name: "原辅助材料",
          menuShow: true
        },
        {
          path: "/EnterpriseFile/Equipment",
          component: resolve =>
            require(["@/pages/enterpriseFile/Equipment/list"], resolve),
          name: "设备设施管理",
          menuShow: true
        },
        {
          path: "/EnterpriseFile/special",
          component: resolve =>
            require(["@/pages/enterpriseFile/Equipment/special"], resolve),
          name: "特种设备管理",
          menuShow: true
        },
        {
          path: "/EnterpriseFile/maintainPlan",
          component: resolve =>
            require(["@/pages/enterpriseFile/maintain/planList"], resolve),
          name: "设备设施维护保养计划",
          menuShow: true
        },
        {
          path: "/EnterpriseFile/inspectBase",
          component: resolve =>
            require(["@/pages/enterpriseFile/inspect/baseList"], resolve),
          name: "设备设施点检模板",
          menuShow: true
        },
        {
          path: "/EnterpriseFile/inspect",
          component: resolve =>
            require(["@/pages/enterpriseFile/inspect/list"], resolve),
          name: "设备设施点检",
          menuShow: true
        },
        {
          path: "/relevant",
          component: Relevant,
          name: "相关方管理",
          menuShow: true
        },
        {
          path: "/relevant/project",
          component: resolve =>
            require(["@/pages/thirdParty/relevant/relevantProject"], resolve),
          name: "委外项目施工信息",
          menuShow: true
        },
        {
          path: "/relevant/relevantDirectory",
          component: resolve =>
            require(["@/pages/thirdParty/relevant/relevantDirectory"], resolve),
          name: "相关方名录",
          menuShow: true
        },
        {
          path: "/relevantApproval",
          component: resolve =>
            require(["@/pages/thirdParty/relevant/approval"], resolve),
          name: "相关方审批",
          menuShow: true
        },
        {
          path: "/relevantExamineBase",
          component: resolve =>
            require(["@/pages/thirdParty/examine/baseList"], resolve),
          name: "相关方考核模板",
          menuShow: true
        },
        {
          path: "/relevantExamine",
          component: resolve =>
            require(["@/pages/thirdParty/examine/list"], resolve),
          name: "相关方考核",
          menuShow: true
        },
        {
          path: "/relevantExamineFuben",
          component: resolve =>
            require(["@/pages/thirdParty/examine/list-fuben"], resolve),
          name: "相关方考核",
          menuShow: true
        },
        {
          path: "/relevantExamineApproval",
          component: resolve =>
            require(["@/pages/thirdParty/examine/approval"], resolve),
          name: "相关方考核审批",
          menuShow: true
        },
        {
          path: "/relevantRisk",
          component: resolve =>
            require(["@/pages/thirdParty/risk/list"], resolve),
          name: "相关方作业行为风险评估",
          menuShow: true
        },
        {
          path: "/relevantRiskBase",
          component: resolve =>
            require(["@/pages/thirdParty/risk/base"], resolve),
          name: "风险评估项目管理设置",
          menuShow: true
        },

        {
          path: "/rel/check/1",
            component: resolve => require(["@/pages/thirdParty/rel/check"], resolve),
          name: "检查内容",
          menuShow: true
        },
        {
          path: "/rel/config",
          component: resolve =>
            require(["@/pages/thirdParty/rel/config"], resolve),
          name: "级别配置",
          menuShow: true
        },
        {
          path: "/rel/inspect",
          component: resolve =>
            require(["@/pages/thirdParty/rel/inspect"], resolve),
          name: "监督检查表",
          menuShow: true
        },

        {
          path: "/relevantCheck",
          component: resolve =>
            require(["@/pages/thirdParty/check/list"], resolve),
          name: "施工方现场检查记录",
          menuShow: true
        },
        {
          path: "/relevantCheckBase",
          component: resolve =>
            require(["@/pages/thirdParty/check/base"], resolve),
          name: "施工方现场检查项目设置",
          menuShow: true
        },
        {
          path: "/relevantSafety",
          component: resolve =>
            require(["@/pages/thirdParty/safety/list"], resolve),
          name: "安全告知管理",
          menuShow: true
        },
        {
          path: "/meetingPlan",
          component: resolve =>
            require(["@/pages/security/meetingPlan/list"], resolve),
          name: "会议计划",
          menuShow: true
        },
        {
          path: "/blacklist",
          component: resolve =>
            require(["@/pages/thirdParty/blacklist/blacklist"], resolve),
          name: "黑名单",
          menuShow: true
        },
        {
          path: "/assessmentRanking",
          component: resolve =>
            require(["@/pages/thirdParty/assessmentRanking/list"], resolve),
          name: "考核排名",
          menuShow: true
        },
        {
          path: "/EnterpriseFile/maintain",
          component: resolve =>
            require(["@/pages/enterpriseFile/maintain/list"], resolve),
          name: "设备保养记录",
          menuShow: true
        },
        {
          path: "/security/spAssManagement",
          component: resolve =>
            require(["@/pages/security/performance/spAssManagement"], resolve),
          name: "考核标准管理",
          menuShow: true
        },
        {
          path: "/security/spTempManagement",
          component: resolve =>
            require(["@/pages/security/performance/spTempManagement"], resolve),
          name: "考核模板管理",
          menuShow: true
        },
        {
          path: "/security/spPerReport",
          component: resolve =>
            require(["@/pages/security/performance/spPerReport"], resolve),
          name: "绩效填报",
          menuShow: true
        },
        {
          path: "/security/spPermanagement",
          component: resolve =>
            require(["@/pages/security/performance/spPermanagement"], resolve),
          name: "绩效管理",
          menuShow: true
        },
        {
          path: "/security/spScoringCriteria",
          component: resolve =>
            require(["@/pages/security/performance/spScoringCriteria"], resolve),
          name: "薪酬得分标准",
          menuShow: true
        },
        {
          path: "/security/spDeductionDetails",
          component: resolve =>
            require(["@/pages/security/performance/spDeductionDetails"], resolve),
          name: "扣分明细表",
          menuShow: true
        },
        {
          path: "/security/spDeductStatistics",
          component: resolve =>
            require(["@/pages/security/performance/spDeductStatistics"], resolve),
          name: "奖扣分统计表",
          menuShow: true
        },
        {
          path: "/security/evaluateTable",
          component: resolve =>
            require(["@/pages/security/performance/evaluateTable"], resolve),
          name: "安全生产责任制考评表",
          menuShow: true
        },
        {
          path: "/security/spPerUser",
          component: resolve =>
            require(["@/pages/security/performance/spPerUser"], resolve),
          name: "自动考评人员维护",
          menuShow: true
        },
        {
          path: "/security/spApprove",
          component: resolve =>
            require(["@/pages/security/performance/spApprove"], resolve),
          name: "领导审批",
          menuShow: true
        },
        {
          path: "/safeMonth/sTemplate",
          component: resolve =>
            require(["@/pages/safeMonth/sTemplate"], resolve),
          name: "工作清单制定",
          menuShow: true
        },
        {
          path: "/safeMonth/planList",
          component: resolve =>
            require(["@/pages/safeMonth/planList"], resolve),
          name: "工作内容录入",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "汇总统计",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/chart/inspection",
          component: resolve =>
            require(["@/pages/statistics/chartInspection"], resolve),
          name: "隐患情况",
          menuShow: true
        },
        {
          path: "/chart/edu",
          component: resolve =>
            require(["@/pages/statistics/chartEdu"], resolve),
          name: "教育培训",
          menuShow: true
        },
        {
          path: "/chart/licence",
          component: resolve =>
            require(["@/pages/statistics/chartLicence"], resolve),
          name: "证照",
          menuShow: true
        },
        {
          path: "/chart/equip",
          component: resolve =>
            require(["@/pages/statistics/chartEquip"], resolve),
          name: "设备设施",
          menuShow: true
        },
        {
          path: "/chart/specialEquip",
          component: resolve =>
            require(["@/pages/statistics/chartSpecialEquip"], resolve),
          name: "特种设备",
          menuShow: true
        },
        {
          path: "/chart/health",
          component: resolve =>
            require(["@/pages/statistics/chartHealth"], resolve),
          name: "职业健康",
          menuShow: true
        },
        {
          path: "/chart/drill",
          component: resolve =>
            require(["@/pages/statistics/chartDrill"], resolve),
          name: "应急演练统计",
          menuShow: true
        },
        {
          path: "/chart/risk",
          component: resolve =>
            require(["@/pages/statistics/chartRisk"], resolve),
          name: "风险管控",
          menuShow: true
        },
        {
          path: "/eventReport",
          component: resolve =>
            require(["@/pages/statistics/eventReport"], resolve),
          name: "事故上报",
          menuShow: true
        }

        // {path: '/staInspection',component: resolve => require(['@/pages/statistics/inspectionList'], resolve), name: '隐患治理统计', menuShow: true},
        // {path: '/trainingStatistics',component: resolve => require(['@/pages/statistics/trainingStatistics'], resolve), name: '培训演练统计', menuShow: true},
        // {path: '/staEvent',component: resolve => require(['@/pages/statistics/eventList'], resolve), name: '安全事故统计', menuShow: true},
      ]
    },
    {
      path: "/",
      component: Home,
      name: "knowledgeBaseLawList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/knowledgeBase/lawList",
          component: LawList,
          name: "法律法规",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "knowledgeBaseSublist",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/knowledgeBase/sublist",
          component: SubList,
          name: "法律法规（子公司）",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "knowledgeBaseRulesTypeList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/knowledgeBase/rulesTypeList",
          component: RulesTypeList,
          name: "规程类型",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "knowledgeBaseRulesList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/knowledgeBase/rulesList",
          component: RulesList,
          name: "规程",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "安全目标名称",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/security/seTargetName",
          component: SeTargetNameList,
          name: "安全目标名称管理",
          menuShow: true
        },
        {
          path: "/security/seGroup",
          component: resolve =>
            require(["@/pages/security/target/seGroup"], resolve),
          name: "分组人员",
          menuShow: true
        },
        {
          path: "/security/accessList",
          component: resolve =>
            require(["@/pages/security/target/accessList"], resolve),
          name: "计划评价",
          menuShow: true
        },
      ]

    },
    {
      path: "/",
      component: Home,
      name: "安全目标",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/security/seTarget",
          component: SeTargetList,
          name: "安全目标管理",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "securitySeNextList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/security/seNextList",
          component: SeNextList,
          name: "待完成安全目标",
          menuShow: true
        }
      ]
    },
    ,
    {
      path: "/",
      component: Home,
      name: "dangerousJobFire",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/task/auditTask/list",
          component: resolve =>
            require(["@/pages/task/auditTask/list"], resolve),
          name: "特殊作业审批表",
          menuShow: true
        },
        {
          path: "/auditTask/file",
          component: resolve =>
            require(["@/pages/task/auditTask/file"], resolve),
          name: "打印审批表",
          menuShow: true
        },
        {
          path: "/auditTask/hazardFile",
          component: resolve =>
            require(["@/pages/task/auditTask/hazardFile"], resolve),
          name: "风险告知卡",
          menuShow: true
        },
        {
          path: "/HotWork/dangerousJobFire",
          component: resolve =>
            require(["@/pages/HotWork/dangerousJobFire"], resolve),
          name: "动火作业初步申请",
          menuShow: true
        },
        {
          path: "/task/lgnitionTask/list",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/list"], resolve),
          name: "动火作业证",
          menuShow: true
        },
        {
          path: "/lgnitionTask/sign",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/sign"], resolve),
          name: "审批",
          menuShow: true
        },
        {
          path: "/lgnitionTask/preliminaryAudit",
          component: resolve =>
            require([
              "@/pages/task/lgnitionTask/examine/preliminaryAudit"
            ], resolve),
          name: "初审",
          menuShow: true
        },
        {
          path: "/lgnitionTask/whenHot",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/whenHot"], resolve),
          name: "证件动火",
          menuShow: true
        },
        {
          path: "/lgnitionTask/monitorCheck",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/monitorCheck"], resolve),
          name: "当班班长验票",
          menuShow: true
        },
        {
          path: "/lgnitionTask/analysisData",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/analysisData"], resolve),
          name: "动火分析数据",
          menuShow: true
        },
        {
          path: "/lgnitionTask/safetyMeasures",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/safetyMeasures"], resolve),
          name: "动火安全措施落实",
          menuShow: true
        },
        {
          path: "/lgnitionTask/workCertificate",
          component: resolve =>
            require([
              "@/pages/task/lgnitionTask/examine/workCertificate"
            ], resolve),
          name: "证件打印",
          menuShow: true
        },
        {
          path: "/lgnitionTask/safetyEducation",
          component: resolve =>
            require([
              "@/pages/task/lgnitionTask/examine/safetyEducation"
            ], resolve),
          name: "安全教育人确认",
          menuShow: true
        },
        {
          path: "/lgnitionTask/file",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/file"], resolve),
          name: "证件归档",
          menuShow: true
        },
        {
          path: "/lgnitionTask/acceptance",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/acceptance"], resolve),
          name: "证件验收",
          menuShow: true
        },
        {
          path: "/lgnitionTask/listBase",
          component: resolve =>
            require(["@/pages/task/securityBaseInfo/listBase"], resolve),
          name: "证件基础安全措施信息",
          menuShow: true
        },
        {
          path: "/lgnitionTask/reportJobFire",
          component: resolve =>
            require(["@/pages/task/examine/reportJobFire"], resolve),
          name: "动火作业证申请",
          menuShow: true
        },
        {
          path: "/HotWork/reportJobFire",
          component: resolve =>
            require(["@/pages/HotWork/reportJobFire"], resolve),
          name: "动火申请",
          menuShow: true
        },
        {
          path: "/HotWork/dangerousJobBasics",
          component: resolve =>
            require(["@/pages/HotWork/dangerousJobBasics"], resolve),
          name: "动火措施基础信息",
          menuShow: true
        },
        {
          path: "/HotWork/preliminaryAudit",
          component: resolve =>
            require(["@/pages/HotWork/preliminaryAudit"], resolve),
          name: "初步审核",
          menuShow: true
        },
        {
          path: "/HotWork/OnSiteAudit",
          component: resolve =>
            require(["@/pages/HotWork/OnSiteAudit"], resolve),
          name: "现场审核",
          menuShow: true
        },
        {
          path: "/HotWork/sign",
          component: resolve => require(["@/pages/HotWork/sign"], resolve),
          name: "会签",
          menuShow: true
        },
        {
          path: "/HotWork/workCertificate",
          component: resolve =>
            require(["@/pages/HotWork/workCertificate"], resolve),
          name: "作业证打印",
          menuShow: true
        },
        {
          path: "/HotWork/WhenHot",
          component: resolve => require(["@/pages/HotWork/WhenHot"], resolve),
          name: "动火",
          menuShow: true
        },
        {
          path: "/HotWork/acceptance",
          component: resolve =>
            require(["@/pages/HotWork/acceptance"], resolve),
          name: "验收",
          menuShow: true
        },
        {
          path: "/limitSpace/list",
          component: resolve =>
            require(["@/pages/task/limitSpace/list"], resolve),
          name: "受限空间安全作业证管理",
          menuShow: true
        },
        {
          path: "/highWok/list",
          component: resolve => require(["@/pages/task/highWok/list"], resolve),
          name: "高处安全作业管理",
          menuShow: true
        },
        {
          path: "/blindTakeBlock",
          component: resolve =>
            require(["@/pages/task/blindTakeBlock/blindTakeBlock"], resolve),
          name: "盲板抽堵安全作业证管理",
          menuShow: true
        },
        {
          path: "/leftWok/list",
          component: resolve => require(["@/pages/task/leftWok/list"], resolve),
          name: "吊装安全作业管理",
          menuShow: true
        },
        {
          path: "/leftWok/leftWokAdd",
          component: resolve =>
            require(["@/pages/task/leftWok/leftWokAdd"], resolve),
          name: "吊装作业申请",
          menuShow: true
        },
        {
          path: "/leftWok/safetyMeasures",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/safetyMeasures"], resolve),
          name: "吊装安全措施落实",
          menuShow: true
        },
        {
          path: "/leftWok/safetyEducation",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/safetyEducation"], resolve),
          name: "吊装安全教育人确认",
          menuShow: true
        },
        {
          path: "/leftWok/workAccept",
          component: resolve =>
            require([
              "@/pages/task/leftWok/Hoisting/workAccept"
            ], resolve),
          name: "接受交底人签字",
          menuShow: true
        },
        {
          path: "/leftWok/acceptance",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/acceptance"], resolve),
          name: "吊装证件验收",
          menuShow: true
        },
        {
          path: "/leftWok/preliminaryAudit",
          component: resolve =>
            require([
              "@/pages/task/leftWok/Hoisting/preliminaryAudit"
            ], resolve),
          name: "吊装证初步审核",
          menuShow: true
        },
        {
          path: "/leftWok/sign",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/sign"], resolve),
          name: "吊装证审核部门审核",
          menuShow: true
        },
        {
          path: "/leftWok/assignment",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/assignment"], resolve),
          name: "吊装证作业",
          menuShow: true
        },
        {
          path: "/leftWok/workCertificate",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/workCertificate"], resolve),
          name: "吊装作业证打印",
          menuShow: true
        },
        {
          path: "/leftWok/reportJobFire",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/reportJobFire"], resolve),
          name: "吊装重新申请",
          menuShow: true
        },
        {
          path: "/leftWok/file",
          component: resolve =>
            require(["@/pages/task/leftWok/Hoisting/file"], resolve),
          name: "吊装作业证打印按钮",
          menuShow: true
        },

        {
          path: "/tempEle/list",
          component: resolve => require(["@/pages/task/tempEle/list"], resolve),
          name: "临时用电安全作业管理",
          menuShow: true
        },
        {
          path: "/tempEle/tempEleAdd",
          component: resolve =>
            require(["@/pages/task/tempEle/tempEleAdd"], resolve),
          name: "临时用电作业申请",
          menuShow: true
        },
        {
          path: "/tempEle/preliminaryAudit",
          component: resolve =>
            require([
              "@/pages/task/tempEle/electric/preliminaryAudit"
            ], resolve),
          name: "临时用电初步审核",
          menuShow: true
        },
        {
          path: "/tempEle/analysisData",
          component: resolve =>
            require([
              "@/pages/task/tempEle/electric/analysisData"
            ], resolve),
          name: "临时用电数据分析",
          menuShow: true
        },
        {
          path: "/tempEle/sign",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/sign"], resolve),
          name: "临时用电会签",
          menuShow: true
        },
        {
          path: "/tempEle/deptAudit",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/deptAudit"], resolve),
          name: "临时用电审批",
          menuShow: true
        },
        {
          path: "/tempEle/workCertificate",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/workCertificate"], resolve),
          name: "临时用电作业证打印",
          menuShow: true
        },
        {
          path: "/tempEle/safetyEducation",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/safetyEducation"], resolve),
          name: "临时用电安全教育人签字",
          menuShow: true
        },
        {
          path: "/tempEle/whenHot",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/whenHot"], resolve),
          name: "临时用电作业证作业",
          menuShow: true
        },
        {
          path: "/tempEle/acceptance",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/acceptance"], resolve),
          name: "临时用电作业证验收",
          menuShow: true
        },
        {
          path: "/tempEle/reportJobFire",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/reportJobFire"], resolve),
          name: "临时用电重新申请",
          menuShow: true
        },
        {
          path: "/tempEle/file",
          component: resolve =>
            require(["@/pages/task/tempEle/electric/file"], resolve),
          name: "临时用电打印",
          menuShow: true
        },

        {
          path: "/certGround",
          component: resolve =>
            require(["@/pages/task/certGround/certGround"], resolve),
          name: "动土安全作业证管理",
          menuShow: true
        },
        {
          path: "/emergency",
          component: resolve =>
            require(["@/pages/task/emergencyFunction"], resolve),
          name: "抢修抢险",
          menuShow: true
        },
        {
          path: "/roadBroken",
          component: resolve =>
            require(["@/pages/task/roadBroken/roadBroken"], resolve),
          name: "断路安全作业证管理",
          menuShow: true
        },
        {
          path: "/roadBroken/roadBrokenAdd",
          component: resolve =>
            require(["@/pages/task/roadBroken/roadBrokenAdd"], resolve),
          name: "断路安全作业申请",
          menuShow: true
        },
        {
          path: "/roadBroken/preliminaryAudit",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/preliminaryAudit"], resolve),
          name: "断路安全初步审核",
          menuShow: true
        },
        {
          path: "/roadBroken/sign",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/sign"], resolve),
          name: "断路安全会签",
          menuShow: true
        },
        {
          path: "/roadBroken/deptAudit",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/deptAudit"], resolve),
          name: "断路安全审批",
          menuShow: true
        },
        {
          path: "/roadBroken/workCertificate",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/workCertificate"], resolve),
          name: "断路安全作业证打印",
          menuShow: true
        },
        {
          path: "/roadBroken/safetyEducation",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/safetyEducation"], resolve),
          name: "断路安全安全教育人签字",
          menuShow: true
        },
        {
          path: "/roadBroken/whenHot",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/whenHot"], resolve),
          name: "断路安全作业证作业",
          menuShow: true
        },
        {
          path: "/roadBroken/acceptance",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/acceptance"], resolve),
          name: "断路安全作业证验收",
          menuShow: true
        },
        {
          path: "/roadBroken/reportJobRoad",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/reportJobRoad"], resolve),
          name: "断路安全重新申请",
          menuShow: true
        },
        {
          path: "/roadBroken/file",
          component: resolve =>
            require(["@/pages/task/roadBroken/road/file"], resolve),
          name: "断路安全打印",
          menuShow: true
        },
        {
          path: "/workSummary/list",
          component: resolve => require(["@/pages/task/workSummary"], resolve),
          name: "特殊作业汇总",
          menuShow: true
        },
        {
          path: "/limitTask/reportJobFire",
          component: resolve =>
            require(["@/pages/task/limitSpace/examine/reportJobFire"], resolve),
          name: "受限空间重新申请",
          menuShow: true
        },
        {
          path: "/limitTask/preliminaryAudit",
          component: resolve =>
            require([
              "@/pages/task/limitSpace/examine/preliminaryAudit"
            ], resolve),
          name: "受限空间初审",
          menuShow: true
        },
        {
          path: "/limitTask/limitDeptExamine",
          component: resolve =>
            require(["@/pages/task/limitSpace/examine/sign"], resolve),
          name: "受限空间审批",
          menuShow: true
        },
        {
          path: "/limitTask/limitDeptExamineFinal",
          component: resolve =>
            require(["@/pages/task/limitSpace/examine/signFinal"], resolve),
          name: "受限空间终审",
          menuShow: true
        },
        {
          path: "/limitTask/limitAnalysisDataExamine",
          component: resolve =>
            require(["@/pages/task/limitSpace/examine/analysisData"], resolve),
          name: "受限空间数据分析",
          menuShow: true
        },
        {
          path: "/limitTask/workCertificate",
          component: resolve =>
            require([
              "@/pages/task/limitSpace/examine/workCertificate"
            ], resolve),
          name: "受限空间作业证打印",
          menuShow: true
        },
        {
          path: "/limitTask/safetyMeasures",
          component: resolve =>
            require([
              "@/pages/task/limitSpace/examine/safetyMeasures"
            ], resolve),
          name: "受限空间安全措施",
          menuShow: true
        },
        {
          path: "/limitTask/safetyEducation",
          component: resolve =>
            require([
              "@/pages/task/limitSpace/examine/safetyEducation"
            ], resolve),
          name: "受限空间安全教育人签字",
          menuShow: true
        },
        {
          path: "/limitTask/workAccept",
          component: resolve =>
            require([
              "@/pages/task/limitSpace/examine/workAccept"
            ], resolve),
          name: "接受交底人签字",
          menuShow: true
        },
        {
          path: "/limitTask/whenHot",
          component: resolve =>
            require(["@/pages/task/limitSpace/examine/whenHot"], resolve),
          name: "受限空间作业证作业",
          menuShow: true
        },
        {
          path: "/limitTask/acceptance",
          component: resolve =>
            require(["@/pages/task/limitSpace/examine/acceptance"], resolve),
          name: "受限空间作业证验收",
          menuShow: true
        },
        {
          path: "/limitTask/file",
          component: resolve =>
            require(["@/pages/task/limitSpace/examine/file"], resolve),
          name: "受限空间作业证打印",
          menuShow: true
        },

        {
          path: "/blindTask/preliminaryAudit",
          component: resolve =>
            require([
              "@/pages/task/blindTakeBlock/examine/preliminaryAudit"
            ], resolve),
          name: "盲板抽堵初审",
          menuShow: true
        },
        {
          path: "/blindTask/blindDeptExamine",
          component: resolve =>
            require(["@/pages/task/blindTakeBlock/examine/sign"], resolve),
          name: "盲板抽堵会签",
          menuShow: true
        },
        {
          path: "/blindTask/deptAudit",
          component: resolve =>
            require(["@/pages/task/blindTakeBlock/examine/deptAudit"], resolve),
          name: "盲板抽堵审批",
          menuShow: true
        },
        {
          path: "/blindTask/workCertificate",
          component: resolve =>
            require([
              "@/pages/task/blindTakeBlock/examine/workCertificate"
            ], resolve),
          name: "盲板抽堵作业证打印",
          menuShow: true
        },
        {
          path: "/blindTask/safetyEducation",
          component: resolve =>
            require([
              "@/pages/task/blindTakeBlock/examine/safetyEducation"
            ], resolve),
          name: "盲板抽堵安全教育人签字",
          menuShow: true
        },
        {
          path: "/blindTask/whenHot",
          component: resolve =>
            require(["@/pages/task/blindTakeBlock/examine/whenHot"], resolve),
          name: "盲板抽堵作业证作业",
          menuShow: true
        },
        {
          path: "/blindTask/acceptance",
          component: resolve =>
            require([
              "@/pages/task/blindTakeBlock/examine/acceptance"
            ], resolve),
          name: "盲板抽堵作业证验收",
          menuShow: true
        },
        {
          path: "/blindTask/reportJobFire",
          component: resolve =>
            require([
              "@/pages/task/blindTakeBlock/examine/reportJobFire"
            ], resolve),
          name: "盲板抽堵重新申请",
          menuShow: true
        },
        {
          path: "/blindTask/file",
          component: resolve =>
            require(["@/pages/task/blindTakeBlock/examine/file"], resolve),
          name: "盲板抽堵打印",
          menuShow: true
        },

        {
          path: "/highTask/preliminaryAudit",
          component: resolve =>
            require(["@/pages/task/highWok/examine/preliminaryAudit"], resolve),
          name: "高处安全初审",
          menuShow: true
        },
        {
          path: "/highTask/blindDeptExamine",
          component: resolve =>
            require(["@/pages/task/highWok/examine/sign"], resolve),
          name: "高处安全会签",
          menuShow: true
        },
        {
          path: "/highTask/deptAudit",
          component: resolve =>
            require(["@/pages/task/highWok/examine/deptAudit"], resolve),
          name: "高处安全审批",
          menuShow: true
        },
        {
          path: "/highTask/workCertificate",
          component: resolve =>
            require(["@/pages/task/highWok/examine/workCertificate"], resolve),
          name: "高处安全作业证打印",
          menuShow: true
        },
        {
          path: "/highTask/safetyMeasures",
          component: resolve =>
            require(["@/pages/task/highWok/examine/safetyMeasures"], resolve),
          name: "高处安全措施落实",
          menuShow: true
        },
        {
          path: "/highTask/safetyEducation",
          component: resolve =>
            require(["@/pages/task/highWok/examine/safetyEducation"], resolve),
          name: "高处安全安全教育人签字",
          menuShow: true
        },
        {
          path: "/highTask/whenHot",
          component: resolve =>
            require(["@/pages/task/highWok/examine/whenHot"], resolve),
          name: "高处安全作业证作业",
          menuShow: true
        },
        {
          path: "/highTask/acceptance",
          component: resolve =>
            require(["@/pages/task/highWok/examine/acceptance"], resolve),
          name: "高处安全作业证验收",
          menuShow: true
        },
        {
          path: "/highTask/reportJobFire",
          component: resolve =>
            require(["@/pages/task/highWok/examine/reportJobFire"], resolve),
          name: "高处安全重新申请",
          menuShow: true
        },
        {
          path: "/highTask/file",
          component: resolve =>
            require(["@/pages/task/highWok/examine/file"], resolve),
          name: "高处安全打印",
          menuShow: true
        },

        {
          path: "/groundTask/preliminaryAudit",
          component: resolve =>
            require([
              "@/pages/task/certGround/examine/preliminaryAudit"
            ], resolve),
          name: "动土作业初审",
          menuShow: true
        },
        {
          path: "/groundTask/groundDeptExamine",
          component: resolve =>
            require(["@/pages/task/certGround/examine/sign"], resolve),
          name: "动土作业会签",
          menuShow: true
        },
        {
          path: "/groundTask/deptAudit",
          component: resolve =>
            require(["@/pages/task/certGround/examine/deptAudit"], resolve),
          name: "动土作业审批",
          menuShow: true
        },
        {
          path: "/groundTask/workCertificate",
          component: resolve =>
            require([
              "@/pages/task/certGround/examine/workCertificate"
            ], resolve),
          name: "动土作业作业证打印",
          menuShow: true
        },
        {
          path: "/groundTask/safetyEducation",
          component: resolve =>
            require([
              "@/pages/task/certGround/examine/safetyEducation"
            ], resolve),
          name: "动土作业安全教育人签字",
          menuShow: true
        },
        {
          path: "/groundTask/whenHot",
          component: resolve =>
            require(["@/pages/task/certGround/examine/whenHot"], resolve),
          name: "动土作业作业证作业",
          menuShow: true
        },
        {
          path: "/groundTask/acceptance",
          component: resolve =>
            require(["@/pages/task/certGround/examine/acceptance"], resolve),
          name: "动土作业作业证验收",
          menuShow: true
        },
        {
          path: "/groundTask/reportJobFire",
          component: resolve =>
            require(["@/pages/task/certGround/examine/reportJobFire"], resolve),
          name: "动土作业重新申请",
          menuShow: true
        },
        {
          path: "/groundTask/file",
          component: resolve =>
            require(["@/pages/task/certGround/examine/file"], resolve),
          name: "动土作业打印",
          menuShow: true
        },
        {
          path: "/cert/report",
          component: resolve =>
            require(["@/pages/task/report/index"], resolve),
          name: "作业票台账",
          menuShow: true
        },
        {
          path: "/SmsMessage",
          component: resolve =>
            require(["@/pages/sms/log"], resolve),
          name: "短信发送记录",
          menuShow: true
        },
        {
          path: "/protectTask/preliminaryAudit",
          component: resolve =>
            require([
              "@/pages/task/labor/examine/preliminaryAudit"
            ], resolve),
          name: "劳保申请初审",
          menuShow: true
        },
        {
          path: "/protectTask/protectDeptExamine",
          component: resolve =>
            require([ "@/pages/task/labor/examine/sign"], resolve),
          name: "劳保申请审批",
          menuShow: true
        },
        {
          path: "/protectTask/warehouseConfirmation",
          component: resolve =>
            require([ "@/pages/task/labor/examine/warehouseConfirmation"], resolve),
          name: "劳保发放",
          menuShow: true
        },
        {
          path: "/protectTask/receiveConfirm",
          component: resolve =>
            require([ "@/pages/task/labor/examine/receiveConfirm"], resolve),
          name: "劳保领用",
          menuShow: true
        },
        {
          path: "/task/engineeringWork/list",
          component: resolve =>
            require(["@/pages/task/engineeringWork/list"], resolve),
          name: "外包工程施工作业证",
          menuShow: true
        },
        {
          path: "/task/engineeringWork/file",
          component: resolve =>
            require(["@/pages/task/engineeringWork/examine/file"], resolve),
          name: "外包工程施工作业证打印",
          menuShow: true
        },
        {
          path: "/lgnitionTask/WorkAccept",
          component: resolve =>
            require(["@/pages/task/lgnitionTask/examine/WorkAccept"], resolve),
          name: "动火接受交底人确认",
          menuShow: true
        },
        {
          path: "/highTask/WorkAccept",
          component: resolve =>
            require(["@/pages/task/highWok/examine/WorkAccept"], resolve),
          name: "高处作业接受交底人确认",
          menuShow: true
        },
        {
          path: "/task/gasWork/list",
          component: resolve =>
            require(["@/pages/task/gasWork/list"], resolve),
          name: "煤气停引作业证",
          menuShow: true
        },
        {
          path: "/task/gasWork/file",
          component: resolve =>
            require(["@/pages/task/gasWork/examine/file"], resolve),
          name: "煤气停引作业证打印",
          menuShow: true
        },
        {
          path: "/task/gasOperateRecord/list",
          component: resolve =>
            require(["@/pages/task/gasOperateRecord/list"], resolve),
          name: "煤气操作票",
          menuShow: true
        },
        {
          path: "/task/gasOperateRecord/file",
          component: resolve =>
            require(["@/pages/task/gasOperateRecord/examine/file"], resolve),
          name: "煤气操作票打印",
          menuShow: true
        },
        {
          path: "/securityBaseInfo/harzdList",
          component: resolve =>
            require(["@/pages/task/securityBaseInfo/harzdList"], resolve),
          name: "安全风险辨识 ",
          menuShow: true
        },
        {
          path: "/auditTask/schemeFile",
          component: resolve =>
            require(["@/pages/task/auditTask/schemeFile"], resolve),
          name: "高风险检修方案",
          menuShow: true
        },
      ]
    },
    {
      path: "/",
      component: Home,
      name: "enterpriseEntAttList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/enterprise/entAttList",
          component: EntAttList,
          name: "企业属性",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "securityStandardList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/security/standardList",
          component: StandardList,
          name: "行业化达标",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "securityIndustryList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/security/industryList",
          component: IndustryList,
          name: "行业资质",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "企业体系文件",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/invest/list",
          component: resolve =>
            require(["@/pages/enterpriseFile/invest/list"], resolve),
          name: "安全投入计划",
          menuShow: true
        },
        {
          path: "/invest/ledger",
          component: resolve =>
            require(["@/pages/enterpriseFile/invest/ledgerlist"], resolve),
          name: "安全费用使用台账",
          menuShow: true
        },
        {
          path: "/invest/subjectlist",
          component: resolve =>
            require(["@/pages/enterpriseFile/invest/subjectlist"], resolve),
          name: "费用科目",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "project manager",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/project",
          component: ProList,
          name: "项目管理",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "基础库管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/safetySignsBase",
          component: resolve =>
            require(["@/pages/security/safetySignsBase/list"], resolve),
          name: "安全标志基础库管理",
          menuShow: true
        },
        {
          path: "/dictionary/list",
          component: DictionaryList,
          name: "基础字典管理",
          menuShow: true
        },
        {
          path: "/platformLoginConfig/list",
          component: resolve =>
          require(["@/pages/security/platformLoginConfig/list"], resolve),
          name: "平台登录配置",
          menuShow: true
        },
        {
          path: "/baseconfig/list",
          component: BaseConfig,
          name: "配置中心",
          menuShow: true
        },
        {
          path: "/typeDictionary/list",
          component: TypeDictionaryList,
          name: "基础类别字典管理",
          menuShow: true
        },
        {
          path: "/regulations/list",
          component: resolve =>
            require(["@/pages/security/regulations/list"], resolve),
          name: "基础操作规程",
          menuShow: true
        },
        {
          path: "/dangerBase/list",
          component: resolve =>
            require(["@/pages/security/dangerBase/list"], resolve),
          name: "基础危险化工工艺",
          menuShow: true
        },
        {
          path: "/templateMatters",
          component: resolve =>
            require(["@/pages/Template/templateMatters"], resolve),
          name: "注意事项基础信息管理",
          menuShow: true
        },
        {
          path: "/templatePrecautions",
          component: resolve =>
            require(["@/pages/Template/templatePrecautions"], resolve),
          name: "安全措施基础信息管理",
          menuShow: true
        }
        ,
        {
          path: "/operations",
          component: operations,
          name: "运维工具箱",
          menuShow: true
        },
        // {path: '/base/basicInfo', component: resolve => require(['@/pages/Hidden/base/basicInfo'], resolve), name: '隐患基础信息管理', menuShow: true},
      ]
    },
    {
      path: "/",
      component: Home,
      name: "培训管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/training/trainingPlan",
          component: resolve =>
            require(["@/pages/training/trainingPlan"], resolve),
          name: "培训计划",
          menuShow: true
        },
        {
          path: "/training/trainingSituation",
          component: resolve =>
            require(["@/pages/training/trainingSituation"], resolve),
          name: "培训情况",
          menuShow: true
        },
        {
          path: "/training/course",
          component: Course,
          name: "课程管理",
          menuShow: true
        },
        {
          path: "/training/questionBank",
          component: resolve =>
            require(["@/pages/training/questionBank"], resolve),
          name: "题库管理",
          menuShow: true
        },
        {
          path: "/training/topic",
          component: resolve => require(["@/pages/training/topic"], resolve),
          name: "提干管理",
          menuShow: true
        },
        {
          path: "/training/testPaper",
          component: resolve =>
            require(["@/pages/training/testPaper"], resolve),
          name: "试卷管理",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "证照管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/card/userCard",
          component: resolve => require(["@/pages/card/userCard"], resolve),
          name: "证照采集",
          menuShow: true
        },
        {
          path: "/card/userCardReview",
          component: resolve =>
            require(["@/pages/card/userCardReview"], resolve),
          name: "证照复审",
          menuShow: true
        },
        {
          path: "/card/userCardWarn",
          component: resolve => require(["@/pages/card/userCardWarn"], resolve),
          name: "证照过期预警",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "学习园地",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/security/staPlaList",
          component: resolve =>
            require(["@/pages/security/security/staPlaList"], resolve),
          name: "标准规范",
          menuShow: true
        },
        {
          path: "/security/accCasList",
          component: resolve =>
            require(["@/pages/security/security/accCasList"], resolve),
          name: "事故案例库",
          menuShow: true
        },
        {
          path: "/security/safCulList",
          component: resolve =>
            require(["@/pages/security/security/safCulList"], resolve),
          name: "安全文化",
          menuShow: true
        },
        {
          path: "/security/safKnoList",
          component: resolve =>
            require(["@/pages/security/security/safKnoList"], resolve),
          name: "安全知识",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "系统监控",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/hystrix",
          meta: { url: "https://www.baidu.com" },
          component: resolve =>
            require(["@/pages/SystemControl/hystrix"], resolve),
          name: "Hystirx监控面板",
          menuShow: true
        },
        {
          path: "/registry",
          meta: { url: "https://www.runoob.com" },
          component: resolve =>
            require(["@/pages/SystemControl/registry"], resolve),
          name: "服务注册",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "隐患计划管理",
      menuShow: true,
      leaf: false,
      children: [
        {
          path: "/inspectionPlan/plan",
          component: resolve =>
            require(["@/pages/inspectionPlan/plan"], resolve),
          name: "隐患计划",
          menuShow: true,
          leaf: true
        },
        {
          path: "/inspectionPlan/check",
          component: resolve =>
            require(["@/pages/inspectionPlan/check"], resolve),
          name: "隐患计划排查",
          menuShow: true,
          leaf: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "MeetingPlanMessageList",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/messageList",
          component: resolve =>
            require(["@/pages/security/meetingPlan/messageList"], resolve),
          name: "消息列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "积分管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/point/pointSettingList",
          component: resolve =>
            require(["@/pages/point/pointSettingList"], resolve),
          name: "积分设置",
          menuShow: true
        },
        {
          path: "/point/pointDetailsList",
          component: resolve =>
            require(["@/pages/point/pointDetailsList"], resolve),
          name: "积分详情",
          menuShow: true
        },
        {
          path: "/point/poinTrankingList",
          component: resolve =>
            require(["@/pages/point/poinTrankingList"], resolve),
          name: "积分排名",
          menuShow: true
        },
        {
          path: "/point/poinModularList",
          component: resolve =>
            require(["@/pages/point/pointModularList"], resolve),
          name: "积分模块设置",
          menuShow: true
        }
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'questionnaire',
      menuShow: true,
      leaf: true,
      children: [
        {
          path: '/questionnaire',
          component: resolve => require(['@/pages/student/questionnaire/questionnaire'], resolve),
          name: '问卷',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'qrCode',
      menuShow: true,
      leaf: true,
      children: [
        {
          path: '/qrCode',
          component: resolve => require(['@/pages/student/qrCode'], resolve),
          name: '二维码',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'tariningPrograms',
      menuShow: true,
      leaf: true,
      children: [
        {
          path: '/tariningProgramList',
          component: resolve => require(['@/pages/trainingManagement/safetyTrainingProgram/trainingProgram/list'], resolve),
          name: '培训计划选择',
          menuShow: true
        },
      ]
    },
    // 预警管理
    {
      path: '/',
      component: Home,
      name: 'alertmanagment',
      menuShow: true,
      leaf: true,
      children: [
        {
          path:"/alert",
          component:AlertComp,
          name:'预警模板设置',
          menuShow: true
        },
      ]
    },
    {
      path: "/",
      component: Home,
      name: "工伤管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/jobInjury",
          component: resolve => require(['@/pages/jobInjury/input'], resolve),
          name: "工伤信息录入",
          menuShow: true
        },
        {
          path: "/jobInjuryManage",
          component: resolve => require(['@/pages/jobInjury/manage'], resolve),
          name: "工伤信息管理",
          menuShow: true
        },
        {
          path: "/work/injury",
          component: resolve => require(['@/pages/jobInjury/injuryInfo'], resolve),
          name: "工伤信息",
          menuShow: true
        },
        {
          path: "/work/injuryWeek",
          component: resolve => require(['@/pages/jobInjury/injuryWeek'], resolve),
          name: "工伤周报",
          menuShow: true
        },
      ]
    },
    {
      path: "/",
      component: Home,
      name: "welcomeInspection",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/listWelcomeInspection",
          component: ListWelcomeInspection,
          name: "迎检计划",
          menuShow: true
        },
        {
          path: "/resultWelcomeInspection",
          component: ResultWelcomeInspection,
          name: "迎检结果",
          menuShow: true
        },
        {
          path: "/rectifyWelcomeInspection",
          component: RectifyWelcomeInspection,
          name: "整改情况",
          menuShow: true
        },
        {
          path: "/acceptWelcomeInspection",
          component: AcceptWelcomeInspection,
          name: "问题验收",
          menuShow: true
        },
        {
          path: "/resultReport",
          component: ResultReport,
          name: "迎检结果",
          menuShow: true
        },
      ]
    },
    {
      path: "/",
      component: Home,
      name: "安全环保",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/outfall",
          component: outfall,
          name: "排口管理",
          menuShow: true
        },
        {
          path: "/radiate",
          component: radiate,
          name: "辐射信息模块",
          menuShow: true
        },
        {
          path: "/epfacilities",
          component: epfacilities,
          name: "环保设施台账",
          menuShow: true
        },
        {
          path: "/manualMonitor",
          component: manualMonitor,
          name: "手工监测数据",
          menuShow: true
        },
        {
          path: "/rainwaterMonitor",
          component: resolve => require(['@/pages/EnvironmentalProtection/epRainwaterMonitor'], resolve),
          name: "雨水排放口监测",
          menuShow: true
        },
        {
          path: "/manualMonitorYear",
          component: resolve => require(['@/pages/EnvironmentalProtection/epmanualMonitorYear'],resolve),
          name: "年度排放口手工监测数据",
          menuShow: true
        },
        {
          path: "/rainwaterMonitorYear",
          component: resolve => require(['@/pages/EnvironmentalProtection/epRainwaterMonitoryear'], resolve),
          name: "年度雨水排放口监测数据",
          menuShow: true
        },
        {
          path: "/factorMaintain",
          component: factorMaintain,
          name: "监测因子维护",
          menuShow: true
        },
        {
          path: "/factorManage",
          component: factorManage,
          name: "监测因子管理",
          menuShow: true
        },
        {
          path: "/discharge",
          component: discharge,
          name: "企业排放总量",
          menuShow: true
        },
        {
          path: "/concentration",
          component: concentration,
          name: "企业排放浓度",
          menuShow: true
        },
        {
          path: "/hourColl/day",
          component: hourCollDay,
          name: "烟气检测日报",
          menuShow: true
        },
        {
          path: "/dayHourColl",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollDayHour'], resolve),
          name: "烟气监测小时均值报表",
          menuShow: true
        },
        {
          path: "/enCollectHour/listA",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectHourA'], resolve),
          name: "烟气监测月报[主要]",
          menuShow: true
        },
        {
          path: "/enCollectHour/listB",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectHourB'], resolve),
          name: "烟气监测月报[一般]",
          menuShow: true
        },
        {
          path: "/enCollectDay/listA",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectDayA'], resolve),
          name: "烟气监测日报[主要]",
          menuShow: true
        },
        {
          path: "/enCollectDay/listB",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectDayB'], resolve),
          name: "烟气监测日报[一般]",
          menuShow: true
        },
        {
          path: "/enCollectDay/listCollect",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectHour'], resolve),
          name: "环保废气监测数据",
          menuShow: true
        },
        {
          path: "/enCollectDay/listQuarter",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollHourQuarter'], resolve),
          name: "环保废气日均数据",
          menuShow: true
        },
        {
          path: "/enCollectGraphsA",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectGraphsA'], resolve),
          name: "烟气监测曲线[主要]",
          menuShow: true
        },
        {
          path: "/enCollectGraphsB",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectGraphsB'], resolve),
          name: "烟气监测曲线[一般]",
          menuShow: true
        },
        {
          path: "/enCollectReport",
          component: resolve => require(['@/pages/EnvironmentalProtection/enCollectReport'], resolve),
          name: "小时数据完整性统计",
          menuShow: true
        },
        {
          path: "/epDosingRecord",
          component: resolve => require(['@/pages/EnvironmentalProtection/epDosingRecord'], resolve),
          name: "加药记录",
          menuShow: true
        },
        {
          path: "/epTransportRecords",
          component: resolve => require(['@/pages/EnvironmentalProtection/epTransportRecords'], resolve),
          name: "脱硫石膏运输记录",
          menuShow: true
        },
        {
          path: "/epUnorganizedEmission",
          component: resolve => require(['@/pages/EnvironmentalProtection/epUnorganizedEmission'], resolve),
          name: "无组织排放数据录入",
          menuShow: true
        },
        {
          path: "/hazWasInfoManagement/epHazardousList",
          component: resolve => require(['@/pages/EnvironmentalProtection/hazWasInfoManagement/ephazardousList'], resolve),
          name: "危险化学品维护",
          menuShow: true
        },
        {
          path: "/hazWasInfoManagement/epProductionWasteRecord",
          component: resolve => require(['@/pages/EnvironmentalProtection/hazWasInfoManagement/epProductionWasteRecord'], resolve),
          name: "产废记录",
          menuShow: true
        },
        {
          path: "/hazWasInfoManagement/epWarehousingRecord",
          component: resolve => require(['@/pages/EnvironmentalProtection/hazWasInfoManagement/epWarehousingRecord'], resolve),
          name: "入库记录",
          menuShow: true
        },
        {
          path: "/hazWasInfoManagement/epTransferRecord",
          component: resolve => require(['@/pages/EnvironmentalProtection/hazWasInfoManagement/epTransferRecord'], resolve),
          name: "出库记录",
          menuShow: true
        },
        {
          path: "/hazardousTask/audit",
          component: resolve => require(['@/pages/EnvironmentalProtection/hazWasInfoManagement/hazardousTaskAudit'], resolve),
          name: "出库记录审批",
          menuShow: true
        },
        {
          path: "/hazWasInfoManagement/epWasteRecord",
          component: resolve => require(['@/pages/EnvironmentalProtection/hazWasInfoManagement/ephazardousWaste'], resolve),
          name: "库存记录",
          menuShow: true
        },
        {
          path: "/epPlanMaintenance",
          component: resolve => require(['@/pages/EnvironmentalProtection/plan/maintenance'], resolve),
          name: "计划停机维护",
          menuShow: true
        },
        {
          path: "/epMonitorOutUpper",
          component: resolve => require(['@/pages/EnvironmentalProtection/plan/epMonitorOutUpper'], resolve),
          name: "有组织监测超标数据",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "接口管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/DataPoints",
          component: resolve => require(['@/pages/ExternalInterface/DataPoints'], resolve),
          name: "对接数据点",
          menuShow: true
        },
        {
          path: "/DataInfo",
          component: resolve => require(['@/pages/ExternalInterface/DataInfo'], resolve),
          name: "对接信息",
          menuShow: true
        },
        {
          path: "/DataLog",
          component: resolve => require(['@/pages/ExternalInterface/DataLog'], resolve),
          name: "发送日志",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "劳保管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/sulPurchase",
          component: resolve => require(['@/pages/task/labor/sulPurchase'], resolve),
          name: "劳保申领",
          menuShow: true
        },
        {
          path: "/laborProtection/ncRecord",
          component: resolve => require(['@/pages/laborProtection/ncRecord'], resolve),
          name: "劳保出库记录",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "有毒气体",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/basicData/toxicGasMaintenance",
          component: resolve => require(['@/pages/toxicGas/basiceData/toxicGasMaintenance'], resolve),
          name: "有毒气体维护",
          menuShow: true
        },
        {
          path: "/basicData/fixedMonitoringDevice",
          component: resolve => require(['@/pages/toxicGas/basiceData/fixedMonitoringDevice/list'], resolve),
          name: "固定监测装置",
          menuShow: true
        },
        {
          path: "/basicData/MonitoringPositionAlarmConfig",
          component: resolve => require(['@/pages/toxicGas/basiceData/MonitoringPositionAlarmConfig'], resolve),
          name: "监测位置报警配置",
          menuShow: true
        },
        {
          path: "/basicData/MAlarmPointManagement",
          component: resolve => require(['@/pages/toxicGas/basiceData/MAlarmPointManagement'], resolve),
          name: "监测报警点管理",
          menuShow: true
        },
        {
          path: "/txAlarm/list",
          component: resolve => require(['@/pages/toxicGas/txAlarmList'], resolve),
          name: "煤气报警监测数据",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "智能应用",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/intelligentApp/equipmentInfo",
          component: resolve => require(['@/pages/intelligentApp/equipmentInfo'], resolve),
          name: "设备信息",
          menuShow: true
        },
        {
          path: "/intelligentApp/equipmentFlow",
          component: resolve => require(['@/pages/intelligentApp/equipmentFlow'], resolve),
          name: "设备流转",
          menuShow: true
        },
        {
          path: "/intelligentApp/alarm",
          component: resolve => require(['@/pages/intelligentApp/alarm'], resolve),
          name: "告警记录",
          menuShow: true
        },
        {
          path: "/intelligentApp/alarmSta",
          component: resolve => require(['@/pages/intelligentApp/alarmSta'], resolve),
          name: "告警统计",
          menuShow: true
        },
      ]
    },
    {
      path: "/",
      component: Home,
      name: "平台数据",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/userData/userList",
          component: resolve => require(['@/pages/loginUserData/loginUserList.vue'], resolve),
          name: "平台数据",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "安全责任书管理",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/safetyResponsibilityLetter/spSafetyBook",
          component: resolve => require(['@/pages/safetyResponsibilityLetter/spSafetyBook'], resolve),
          name: "签订模板维护",
          menuShow: true
        },
        {
          path: "/safetyResponsibilityLetter/spSafetySign",
          component: resolve => require(['@/pages/safetyResponsibilityLetter/spSafetySign'], resolve),
          name: "安全责任书签订",
          menuShow: true
        },
        {
          path: "/safetyResponsibilityLetter/spSafertPromise",
          component: resolve => require(['@/pages/safetyResponsibilityLetter/spSafertPromise'], resolve),
          name: "安全承诺书签订",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "周报统计",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/weekly/weeklyReport",
          component: resolve => require(['@/pages/weekly/weeklyReport'], resolve),
          name: "周报填报",
          menuShow: true
        },
        {
          path: "/weekly/weeklyCollect",
          component: resolve => require(['@/pages/weekly/weeklyCollect'], resolve),
          name: "周报汇总",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "系统报表",
      menuShow: true,
      leaf: true,
      children: [
        {
          path: "/riskPatrol/report",
          component: resolve => require(['@/pages/MainReports/riskPatrolIndex'], resolve),
          name: "风险巡查报表",
          menuShow: true
        },
        {
          path: "/firePoint/report",
          component: resolve => require(['@/pages/MainReports/firePointIndex'], resolve),
          name: "防火巡查报表",
          menuShow: true
        },
        {
          path: "/fireControl/report",
          component: resolve => require(['@/pages/MainReports/fireControlIndex'], resolve),
          name: "消防设施点检报表",
          menuShow: true
        },
        {
          path: "/inspectCompare/report",
          component: resolve => require(['@/pages/MainReports/inspectCompareIndex'], resolve),
          name: "隐患整改对比表",
          menuShow: true
        },
      ]
    },

    ...newRouter
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith("/login") || to.path.startsWith("/oaLogin")) {
    window.localStorage.removeItem("access-token");
    next();
  } else if (to.path.startsWith("/index")) {
    next();
  } else if (to.path.includes("http")) {
    window.open(to.fullPath.substr(1));
  } else if(to.path.indexOf("workCertificatePreview") != -1){
    next();
  } else {
    let user = window.localStorage.getItem("access-token");
    if (!user) {
      next({ path: "/login" });
    } else {
      next();
    }
  }
});




export default router;



// WEBPACK FOOTER //
// ./src/router/index.js